import React from 'react';
import FormControl from 'react-bootstrap/FormControl';
import EditProfileModal from 'components/EditProfileModal';
import { getImageWithBackground } from 'components/UserAvatar/utils';
import Edit from './edit-button.svg';
import './ProfileDetailCard.css';

const EditButton = ({ alt, onEdit }) => {
  return (
    <button type="button" className="patron-details-edit-btn" onClick={onEdit}>
      <img src={Edit} alt={alt} />
    </button>
  );
};

const EditableDetailCard = ({ label, value, onEdit, alt, customClasses }) => {
  return (
    <div className={`patron-card ${customClasses ? customClasses : ''}`}>
      <div className="editable-detail-container">
        <div className="detail-label">{label}</div>
        <div className="detail-value">{value}</div>
      </div>
      {onEdit && <EditButton onEdit={onEdit} alt={alt} />}
    </div>
  );
};

const DetailRow = ({ label, value, isRow }) => {
  const directionClass = isRow ? 'detail-row-row' : 'detail-row-col';
  return (
    <div className={`detail-row ${directionClass}`}>
      <div className="detail-label">{label}</div>
      <div className="detail-value" title={value}>
        {value}
      </div>
    </div>
  );
};

const DetailSection = ({ header, details, isFlex, isRow }) => {
  const className = isFlex ? 'detail-flex' : 'detail-grid';
  return (
    <div className="detail-section">
      {header && <div className="detail-header">{header}</div>}
      <div className={className}>
        {details.map((detail, index) => (
          <DetailRow key={index} {...detail} isRow={isRow} />
        ))}
      </div>
    </div>
  );
};

export const StaticPatronCard = ({ userDetails }) => {
  return (
    <div className="static-detail-card">
      {userDetails.map((detailSection, index) => (
        <DetailSection key={index} {...detailSection} />
      ))}
    </div>
  );
};

export const DynamicPatronCard = ({
  details,
  onEdit,
  editingOnDesktop,
  showEditModal,
  closeEditModal,
  onChange,
  onlineJoinDate,
  renderButtons,
  handleSubmit,
  displayName,
  onlineEmail
}) => {
  const detailElements = details.map((detail, index) => (
    <div className="detail-container" key={index}>
      {editingOnDesktop ? (
        <>
          <div className="detail-label">{detail.label}</div>
          <FormControl
            className={
              detail.errorMessage ? 'form-control error-input' : 'form-control'
            }
            type="text"
            id={detail.id}
            name={detail.name}
            value={detail.value}
            onChange={onChange}
          />
          {detail.errorMessage && (
            <div className="error-text">{detail.errorMessage}</div>
          )}
        </>
      ) : (
        <DetailRow label={detail.label} value={detail.value} />
      )}
      {detail.emailChanged?.onlineEmail && (
        <div className="success-text">
          <p>{`[${detail.emailChanged.onlineEmail}]`}</p>
          {detail.emailChanged.message}
        </div>
      )}
    </div>
  ));

  return (
    <>
      <div className="dynamic-detail-card">
        {onEdit && <EditButton onEdit={onEdit} />}
        {detailElements}
        {onlineJoinDate && (
          <div className="detail-section">
            <DetailRow
              label={'Online Join Date'}
              value={onlineJoinDate}
              isRow={true}
            />
          </div>
        )}
        {editingOnDesktop && renderButtons()}
      </div>
      <EditProfileModal
        showEditModal={showEditModal}
        closeEditModal={closeEditModal}
        onChange={onChange}
        handleSubmit={handleSubmit}
        displayName={displayName}
        onlineEmail={onlineEmail}
      />
    </>
  );
};

export const ProfileVenueCard = ({ venueData, onEdit }) => {
  if (!venueData) {
    return (
      <EditableDetailCard
        label="Favorite Venue"
        value="Not Selected"
        onEdit={onEdit}
        alt="Edit venue preference"
      />
    );
  }
  const { image: venueIcon, name: venue, address: venueAddress } = venueData;
  return (
    <div className="patron-card venue-card">
      <div className="detail-with-icon-container">
        <div className="detail-label">My Venue</div>
        <div className="venue-container">
          <div className="icon">
            <img src={venueIcon} alt="" />
          </div>
          <div className="text-container">
            <span className="pref-location">{venue}</span>
            <div>{venueAddress}</div>
          </div>
        </div>
      </div>
      {onEdit && <EditButton onEdit={onEdit} />}
    </div>
  );
};

export const ProfileAvatarCard = ({ avatarData, onEdit }) => {
  return (
    <EditableDetailCard
      label="My Avatar"
      value={
        avatarData ? (
          avatarData
        ) : (
          <img src={getImageWithBackground('Avatar-0')} alt={'Avatar-0'} />
        )
      }
      onEdit={onEdit}
      alt="Edit profile avatar"
      customClasses={'edit-profile-avatar'}
    />
  );
};
